// Lib
import { oc } from "ts-optchain";

// Services
import { ObjectUtil } from "@/services";

// Types
import {
  CartOrderType,
  IOrderOptionsDto,
  IShoppingCartListResponseDto,
  PartValidationReason,
} from "@/types";
import {
  IShoppingCartContext,
} from "../Types";

export class CartService {

  public static getOrderType(context: IShoppingCartContext): CartOrderType {
    const items = context.cartData.Items;

    const mcfa = items.some((p) => !CartService.isRpiServiced(p));
    const rpi = items.some((p) => CartService.isRpiServiced(p));

    if (mcfa && rpi) {
      return CartOrderType.Both;
    }

    return mcfa ? CartOrderType.Mcfa : CartOrderType.RapidParts;
  }

  public static isRpiServiced(dto: any): boolean {
    return oc(dto as any).isRpiServiced(false);
  }

  public static canProceedToStep2(context: IShoppingCartContext, cartData: IShoppingCartListResponseDto) {
    return (
      cartData.Items.length > 0 &&
      cartData.Items.every((x) => x.PartValidation.IsValid === true || x.PartValidation.ValidationReason === PartValidationReason.IsValid)
    );
  }

  public static canProceedToStep3(context: IShoppingCartContext, cartData: IShoppingCartListResponseDto, offlineToSap: boolean, offlineToWarehouseSystems: boolean) {
    var allowedValidationReasons = [
      '35', //OfflineToSap
      '37', //OfflineToWarehouseSystems
    ];

    //if mixmax override is on, allow that reason as well
    if(context.mixMaxValidationOverride){
      allowedValidationReasons.push('19'); //MixMaxOverride
    }

    //filter out allowed validation reasons
    cartData.ValidationResults.ValidationErrors = cartData.ValidationResults.ValidationErrors.filter(ve => {
      var reasonStr = ve.Reason.toString();
      return allowedValidationReasons.indexOf(reasonStr) === -1;
    })

    // Determine if there are any remaining validation errors
    var orderErrors = cartData.ValidationResults.ValidationErrors.length > 0

    return !orderErrors && CartService.canSubmitOrder(context, cartData, offlineToSap, offlineToWarehouseSystems);
  }

  public static canSubmitOrder(context: IShoppingCartContext, cartData: IShoppingCartListResponseDto, offlineToSap: boolean, offlineToWarehouseSystems: boolean) {
    // allow cart submission if SAP is offline
    if(offlineToSap || offlineToWarehouseSystems){
      return (
        cartData.Items.length > 0
      );
    }
    
    return (
      cartData.Items.length > 0 &&
      cartData.Items.every((x) => x.PartValidation.IsValid === true || x.PartValidation.ValidationReason === PartValidationReason.IsValid )
    );
  }

  public static getOrCreateOrderOptions(context: any): any {
    return (
      context.orderOptions ??
      ObjectUtil.createInstance<IOrderOptionsDto>({
        IgnorePoNumber:false,
        IsWarrantyClaim: false,
        WarrantyModel: "",
        WarrantySerial: "",
        IsShipToCustomer: false,
        CustomerAddressName: "",
        CustomerAddressName2: "",
        CustomerAddress1: "",
        CustomerAddress2: "",
        CustomerCity: "",
        CustomerStateProvince: "",
        CustomerPostalCode: "",
        CustomerCountryCode: "",
        ShouldSaveCustomerAddress: false,
        IsEmergencyShipTo: false,
        EmergencyAddressName: "",
        EmergencyAddress1: "",
        EmergencyAddress2: "",
        EmergencyCity: "",
        EmergencyStateProvince: "",
        EmergencyPostalCode: "",
        EmergencyCountryCode: "",
        IsFinalToCustomer: false,
        FinalToCustomerAddressName: "",
        FinalToCustomerAddress1: "",
        FinalToCustomerAddress2: "",
        FinalToCustomerCity: "",
        FinalToCustomerStateProvince: "",
        FinalToCustomerPostalCode: "",
        FinalToCustomerCountryCode: "",
        FinalToShouldSaveCustomerAddress: false,
        AlternateWarehouses: [],
        DropShipOverrides: [],
        Other3pShippingAccounts: [],
        SapFreightTerm: "",
      })
    );
  }
}
